import React from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

export enum PlanType {
    ALL = "--",
    MONTHLY = "定額",
    USAGE_BASED = "従量",
}

const planOptions = [
    { type: PlanType.ALL, code: "all" },
    { type: PlanType.MONTHLY, code: "monthly" },
    { type: PlanType.USAGE_BASED, code: "usage_based" },
];

export interface PlanTypePulldownState {
    selectedPlanType: string | null;
    onChange: (planType: string) => void;
}

export const PlanTypePulldown: React.FC<PlanTypePulldownState> = (
    props: PlanTypePulldownState
) => {
    const initval = props.selectedPlanType ? props.selectedPlanType : "";
    const options = [] as JSX.Element[];

    options.push(
        ...planOptions.map((n) => {
            return (
                <MenuItem key={`plan_${n.code}`} value={n.code}>
                    {n.type}
                </MenuItem>
            );
        })
    );

    return (
        <TextField
            id="plantype-select"
            value={initval}
            select
            variant="filled"
            label="契約種別"
            size="small"
            sx={{
                mr: 4,
                ml: 4,
                width: "200px",
                textAlign: "center",
            }}
            onChange={(ev) => {
                props.onChange(ev.target.value);
            }}
        >
            {options}
        </TextField>
    );
};
